/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SubscriptionPriceInterval } from './SubscriptionPriceInterval';
import {
    SubscriptionPriceIntervalFromJSON,
    SubscriptionPriceIntervalFromJSONTyped,
    SubscriptionPriceIntervalToJSON,
    SubscriptionPriceIntervalToJSONTyped,
} from './SubscriptionPriceInterval';

/**
 * 
 * @export
 * @interface SubscriptionCreatePriceBody
 */
export interface SubscriptionCreatePriceBody {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionCreatePriceBody
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionCreatePriceBody
     */
    productId: string;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionCreatePriceBody
     */
    price: number;
    /**
     * 
     * @type {SubscriptionPriceInterval}
     * @memberof SubscriptionCreatePriceBody
     */
    interval?: SubscriptionPriceInterval;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionCreatePriceBody
     */
    intervalCount?: number;
}



/**
 * Check if a given object implements the SubscriptionCreatePriceBody interface.
 */
export function instanceOfSubscriptionCreatePriceBody(value: object): value is SubscriptionCreatePriceBody {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('productId' in value) || value['productId'] === undefined) return false;
    if (!('price' in value) || value['price'] === undefined) return false;
    return true;
}

export function SubscriptionCreatePriceBodyFromJSON(json: any): SubscriptionCreatePriceBody {
    return SubscriptionCreatePriceBodyFromJSONTyped(json, false);
}

export function SubscriptionCreatePriceBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionCreatePriceBody {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'productId': json['productId'],
        'price': json['price'],
        'interval': json['interval'] == null ? undefined : SubscriptionPriceIntervalFromJSON(json['interval']),
        'intervalCount': json['intervalCount'] == null ? undefined : json['intervalCount'],
    };
}

export function SubscriptionCreatePriceBodyToJSON(json: any): SubscriptionCreatePriceBody {
    return SubscriptionCreatePriceBodyToJSONTyped(json, false);
}

export function SubscriptionCreatePriceBodyToJSONTyped(value?: SubscriptionCreatePriceBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'productId': value['productId'],
        'price': value['price'],
        'interval': SubscriptionPriceIntervalToJSON(value['interval']),
        'intervalCount': value['intervalCount'],
    };
}

